import React from 'react';

type IconProps = {
    width?: number;
    height?: number;
    color?: string;
};

const IconThreadsShare: React.FC<IconProps> = ({ width = 25, height = 24, color = 'white' }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 25 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M18.2514 17.8112L15.0017 14.5615C14.7084 14.2683 14.7084 13.7942 15.0017 13.501C15.2949 13.2077 15.7689 13.2077 16.0622 13.501L18.0317 15.4705V7.28125C18.0317 6.04075 17.0222 5.03125 15.7817 5.03125H5.78119C5.36644 5.03125 5.03119 4.69525 5.03119 4.28125C5.03119 3.86725 5.36644 3.53125 5.78119 3.53125H15.7817C17.8494 3.53125 19.5317 5.2135 19.5317 7.28125V15.4705L21.5012 13.501C21.7944 13.2077 22.2684 13.2077 22.5617 13.501C22.8549 13.7942 22.8549 14.269 22.5617 14.5623L19.3119 17.812C19.2611 17.8542 19.0681 18.0041 18.7798 18.0033C18.4936 18.0025 18.3025 17.8538 18.2514 17.8112ZM5.25094 6.1885L2.00119 9.43825C1.70794 9.7315 1.70794 10.2055 2.00119 10.4987C2.29444 10.792 2.76844 10.792 3.06169 10.4987L5.03119 8.52925V16.468C5.03119 18.6737 6.82594 20.4678 9.03094 20.4678H18.7817C19.1964 20.4678 19.5317 20.1318 19.5317 19.7178C19.5317 19.3038 19.1964 18.9692 18.7817 18.9692H9.03094C7.65244 18.9692 6.53119 17.8472 6.53119 16.4695V8.53L8.50069 10.4995C8.64694 10.6457 8.83894 10.7192 9.03094 10.7192C9.22294 10.7192 9.41494 10.6457 9.56119 10.4995C9.85444 10.2062 9.85444 9.73225 9.56119 9.439L6.31144 6.1885C6.27581 6.15302 6.08405 5.96927 5.78053 5.96955C5.47786 5.96978 5.28675 6.15288 5.25094 6.1885Z"
                fill={color}
            />
        </svg>
    );
};

export default IconThreadsShare;
